/**
 * 主题样式 mixin
 * 使用说明：引入此 mixin 后，直接使用 class="theme-btn-outline" 或 class="theme-text" 即可
 */
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('theme', ['currentThemeConfig']),
        
        // 主题CSS变量（自动绑定到根元素）
        themeVars() {
            const config = this.currentThemeConfig;
            return {
                '--theme-primary-color': config.btnPrimaryColor,//线框btn-按钮文字颜色
                '--theme-primary-border': config.btnPrimaryBorder,//线框btn-按钮边框颜色
                '--theme-text-color': config.textColor,//主题色-文案颜色
                '--theme-btn-background': config.btnBackground,//实心按钮背景色
                '--theme-page-background': config.pageBackground,//页面长背景色
                '--theme-page-short-background': config.pageShortBackground,//页面短背景色
                '--theme-page-long-background': config.pageLongBackground,//页面长渐变背景色
                '--theme-nav-background': config.navBackground,//导航栏短背景色
                '--theme-nav-long-background': config.navLongBackground,//导航栏长背景色
                '--theme-icon-color': config.iconColor,//健康指标带icon的按钮的icon颜色
                '--theme-button-background': config.buttonBackground,//健康指标带icon的按钮的背景色
            };
        }
    }
};
